module.exports = __webpack_public_path__ + "static/puto-paw-28dc4b83c9a70e196154da5ecaa1e71c.jpg";